























































import { defineComponent, reactive, toRefs, onMounted, watch } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { SearchCondition, Course } from "../../modules/teacher/CourseList"

export interface Data {
  tabNo: number
  condition: SearchCondition
  courses: Course[]
  fields: any[]
  errors: string[]
  isAllCheckedDelete: boolean
  delete_ids: number[]
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 3,
      condition: new SearchCondition(),
      courses: new Array<Course>(),
      fields: [
        {key: "course_code", label: "講座CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "course_type", label: "講座種別", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "講座名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "grade", label: "学年", sortable: true, class: 'text-center b-table-th-td'},
        {key: "delete", label: "削除", class: 'text-center'},
      ],
      errors: [],
      isAllCheckedDelete: false,
      delete_ids: [],
    });

    /************************************************************
     * 削除処理
     ************************************************************/

    const deleteCourse = async (): Promise<void> => {

      if (!state.delete_ids.length) {
        alert(`削除する教室をチェックしてください。`);
        return;
      }

      if (!confirm(`本当に削除してよろしいでしょうか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/course_list/delete_course`, {ids: state.delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      search();
    }

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/course_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.courses = response.data.courses.map((x: any) => new Course(x)); 
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {

      context.root.$store.dispatch("showOverlay", "ダウンロード中... しばらくお待ちください。");

      await http.get(`/api/course_list/download?${Common.BuildQuery(state.condition, 'search_condition')}`, {responseType: 'arraybuffer'}).then(async response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `講座マスタ.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    watch(() => state.isAllCheckedDelete, (newVal, oldVal) => {

      state.delete_ids = [];

      if (newVal) {
        state.delete_ids = state.courses.map(x => x.id);
      }
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
    });

    return {
      ...toRefs(state),
      search,
      clearCondition,
      deleteCourse,
      download,
    };
  }
});
